
import React, { Children } from 'react';
import StyleWrapper from "./Wrapper";

function Footer(props) {

  return (
    <StyleWrapper className="footer">
      { "@ 2018 Project X" }
    </StyleWrapper>
  );
}
export default Footer;





// WEBPACK FOOTER //
// ./src/components/Footer/index.js